/**
 * 事務局確認用ステータス（顧客要望 管理No.25）など、自治体が任意に設定する hex 色を
 * チップ／カード背景に使う際の前景（文字）色を相対輝度から決めるユーティリティ。
 */

/** "#1677ff" / "#abc" / "1677ff" を {r,g,b} に変換。不正値は null。 */
function parseHexColor(hex: string): { r: number; g: number; b: number } | null {
  if (!hex) return null
  let value = hex.trim().replace(/^#/, '')
  if (value.length === 3) {
    value = value
      .split('')
      .map((c) => c + c)
      .join('')
  }
  if (value.length !== 6 || /[^0-9a-fA-F]/.test(value)) return null
  return {
    r: parseInt(value.slice(0, 2), 16),
    g: parseInt(value.slice(2, 4), 16),
    b: parseInt(value.slice(4, 6), 16),
  }
}

/**
 * 背景色 hex に対して読みやすい文字色（黒/白）を返す。
 * WCAG 相対輝度のしきい値で判定し、明るい背景には黒、暗い背景には白を返す。
 * 不正値は黒を返す。
 */
export function readableTextColor(backgroundHex: string): string {
  const rgb = parseHexColor(backgroundHex)
  if (!rgb) return 'rgba(0, 0, 0, 0.88)'
  const toLinear = (channel: number) => {
    const c = channel / 255
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)
  }
  const luminance =
    0.2126 * toLinear(rgb.r) + 0.7152 * toLinear(rgb.g) + 0.0722 * toLinear(rgb.b)
  return luminance > 0.5 ? 'rgba(0, 0, 0, 0.88)' : '#ffffff'
}

/** 有効な hex 色か。Tag/Card に色を渡す前のフォールバック判定に使う。 */
export function isValidHexColor(hex: string | null | undefined): hex is string {
  return !!hex && parseHexColor(hex) !== null
}
